import { Component, OnInit, HostBinding, ElementRef, ViewChild } from '@angular/core';
import { RealTimeContextService } from 'app/real-time/real-time-context.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Subscription } from 'rxjs/Subscription';
import {MapContextService} from '../../common/map-context.service';

@Component({
  selector: 'app-mobile-popup',
  templateUrl: './mobile-popup.component.html',
  styleUrls: ['./mobile-popup.component.scss']
})
export class MobilePopupComponent implements OnInit, OnDestroy {
  public visible: boolean;
  @HostBinding('class.showing') isVisible = false;
  @ViewChild('popupContent') popupContent: ElementRef;
  private subscription: Subscription;
  constructor(private mapContext: MapContextService) { }

  ngOnInit() {
    this.subscription = this.mapContext.mobilePopup.subscribe((popup) => {
      this.setIsVisible(true);
      this.popupContent.nativeElement.innerHTML = '';
      this.popupContent.nativeElement.appendChild(popup);
    })
  }

  setIsVisible(isVisible) {
    this.isVisible = isVisible;
  }

  closePopup() {
    this.setIsVisible(false);
    this.popupContent.nativeElement.innerHTML = '';
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/real-time/mobile-popup/mobile-popup.component.ts